import { render } from "./RegionDashboardsDynamicCards.vue?vue&type=template&id=14edbf73&scoped=true&ts=true"
import script from "./RegionDashboardsDynamicCards.vue?vue&type=script&lang=ts"
export * from "./RegionDashboardsDynamicCards.vue?vue&type=script&lang=ts"

import "./RegionDashboardsDynamicCards.vue?vue&type=style&index=0&id=14edbf73&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14edbf73"]])

export default __exports__